import React, { useEffect } from 'react';
import { Form, FormInstance, SelectBooleanInput } from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface GenericSettingsData {
  alerts?: boolean;
  afterHourInfo?: boolean;
  trigger?: number;
}

const DefaultSettings: GenericSettingsData = {
  alerts: true,
  afterHourInfo: false,
  trigger: 1
};

interface GenericSettingsProps {
  setForm?: (form: FormInstance<GenericSettingsData>) => void;
  onSubmit?: (data: GenericSettingsData) => void;
  disabled?: boolean;
}

const GenericSettings = ({
  setForm,
  onSubmit,
  disabled
}: GenericSettingsProps): JSX.Element => {
  const form = new FormInstance<GenericSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="afterHourInfo"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default GenericSettings;
